import HttpService from '../../../services/http/httpService';
import config from '../../../config';

const limpiar = (valor) => (typeof valor === 'string' ? valor.trim() : '');

// silent: true para que el error llegue a React Query y la vista pinte el
// mensaje del backend inline en vez del toast global.
class NotasD2lService extends HttpService {
  // GET /obtenerNotasD2L -> { table, total, page, pageSize, rows: [...] }
  async obtenerNotas({ headquarter, nombre, apellido, oferta, page, pageSize }) {
    const filtros = {
      nombre: limpiar(nombre),
      apellido: limpiar(apellido),
      oferta: limpiar(oferta),
    };
    const params = { headquarter, page, pageSize };
    Object.entries(filtros).forEach(([clave, valor]) => {
      if (valor) params[clave] = valor;
    });
    return this.get('obtenerNotasD2L', { params, silent: true });
  }
}

const notasD2lService = new NotasD2lService(config.REACT_APP_NODE_API);
export default notasD2lService;
